"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainBuilder = exports.ChainDirection = void 0;
const ChainDefinition_1 = require("./ChainDefinition");
var ChainDirection;
(function (ChainDirection) {
    ChainDirection["ClientFirst"] = "ClientFirst";
    ChainDirection["ServerFirst"] = "ServerFirst";
})(ChainDirection = exports.ChainDirection || (exports.ChainDirection = {}));
class ChainBuilder {
    constructor(id) {
        this.clientSends = (payload) => {
            return new CBServerContext(this.id, [payload], ChainDirection.ClientFirst);
        };
        this.serverSends = (payload) => {
            return new CBClientContext(this.id, [payload], ChainDirection.ServerFirst);
        };
        this.id = id;
    }
}
exports.ChainBuilder = ChainBuilder;
class CBClientContext {
    constructor(id, chain, direction) {
        this.clientSends = (payload) => {
            return new CBServerContext(this.id, [...this.chain, payload], this.direction);
        };
        this.end = () => {
            return new ChainDefinition_1.ChainDefinition(this.id, this.chain, this.direction);
        };
        this.id = id;
        this.chain = chain;
        this.direction = direction;
    }
}
class CBServerContext {
    constructor(id, chain, direction) {
        this.serverSends = (payload) => {
            return new CBClientContext(this.id, [...this.chain, payload], this.direction);
        };
        this.end = () => {
            return new ChainDefinition_1.ChainDefinition(this.id, this.chain, this.direction);
        };
        this.id = id;
        this.chain = chain;
        this.direction = direction;
    }
}
//# sourceMappingURL=ChainBuilder.js.map